import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-viewsupport',
  templateUrl: './viewsupport.component.html',
  styleUrls: ['./viewsupport.component.css']
})
export class ViewsupportComponent implements OnInit {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  supportColl: any = [];

  supportform = new FormGroup({
    supportid: new FormControl(0),
    comments: new FormControl(''),
    isclosed: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Support";

  @Input() supportid: number = 0

  @Input() supportBO: any = null;
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {


  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.supportform.reset();
      this.fnInitializesupport();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.supportid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    _check = true;
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializesupport() {
  
    this.supportform.setValue({
      supportid: this.supportBO.supportid,
      comments: this.supportBO.comments,
      isclosed: this.supportBO.isclosed,
    })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.supportform.valid) {
        this.saveloading = true
        //Check
        var data = {
          'supportid': this.supportid,
          'comments': this.supportform.get('comments').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'isclosed': this.supportform.get('isclosed').value,
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnsetSupport(data).subscribe(
          (res) => {

            if (res.json().status === 200) {
              this.toastr.success('', "Status Updated..");
              this.emitData.emit("DONE");
              this.activeModal.close(true);
            } else {
              this.saveloading = false

              this.toastr.error('Error', "");
            };
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }


  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
